import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
} from "@mui/material";
import { ConnectorConfigFormProps } from "../models/Connector";
import CXoneConnector, { CXoneFormValues } from "../models/CXOneConnector";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ConnectorSecretField } from "../input/ConnectorSecretField";

const CXOneConfigForm = ({
  defaultValues,
  register,
  control,
  errors,
}: ConnectorConfigFormProps<CXoneFormValues, "CXone">) => {
  const { t } = useTranslation("cxoneConnector");
  const registerPrefix = CXoneConnector.Type;

  return (
    <>
      <FormGroup>
        <Controller
          name={`${registerPrefix}.clientId`}
          render={({ field }) => (
            <ConnectorSecretField
              {...field}
              label={t("cxoneConnector:clientId")}
              defaultValue={defaultValues.clientId?.value}
              error={!!errors?.CXone?.clientId}
            />
          )}
        />
        {errors?.CXone?.clientId?.value?.message && (
          <FormHelperText error>
            <>{t(errors.CXone.clientId.value?.message)}</>
          </FormHelperText>
        )}
      </FormGroup>
      <FormGroup>
        <Controller
          name={`${registerPrefix}.clientSecret`}
          render={({ field }) => (
            <ConnectorSecretField
              {...field}
              label={t("cxoneConnector:clientSecret")}
              defaultValue={defaultValues.clientSecret?.value}
              error={!!errors?.CXone?.clientSecret}
            />
          )}
        />
        {errors?.CXone?.clientSecret?.value?.message && (
          <FormHelperText error>
            <>{t(errors.CXone.clientSecret.value?.message)}</>
          </FormHelperText>
        )}
      </FormGroup>
      <FormGroup>
        <Controller
          name={`${registerPrefix}.accessKey`}
          render={({ field }) => (
            <ConnectorSecretField
              {...field}
              label={t("cxoneConnector:accessKey")}
              defaultValue={defaultValues.accessKey?.value}
              error={!!errors?.CXone?.accessKey}
              required
            />
          )}
        />
        {errors?.CXone?.accessKey?.value?.message && (
          <FormHelperText error>
            <>{t(errors.CXone.accessKey.value?.message)}</>
          </FormHelperText>
        )}
      </FormGroup>
      <FormGroup>
        <Controller
          name={`${registerPrefix}.secretKey`}
          render={({ field }) => (
            <ConnectorSecretField
              {...field}
              label={t("cxoneConnector:secretKey")}
              defaultValue={defaultValues.secretKey?.value}
              error={!!errors?.CXone?.secretKey}
              required
            />
          )}
        />
        {errors?.CXone?.secretKey?.value?.message && (
          <FormHelperText error>
            <>{t(errors.CXone.secretKey.value.message)}</>
          </FormHelperText>
        )}
      </FormGroup>
      <FormGroup>
        <FormControlLabel
          label={t("cxoneConnector:shouldSaveNoMedia")}
          control={
            <Controller
              name="shouldSaveNoMedia"
              control={control}
              render={({ field }) => (
                <Checkbox
                  {...field}
                  checked={field.value}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                    field.onChange(event.target.checked)
                  }
                />
              )}
            />
          }
        />
        {errors?.shouldSaveNoMedia?.message && (
          <FormHelperText error>
            <>{errors.shouldSaveNoMedia.message}</>
          </FormHelperText>
        )}
      </FormGroup>
    </>
  );
};

export default CXOneConfigForm;
